
<div class="header bg-gradient-success pb-8 pt-5 pt-md-8" >
</div>
<div class="container-fluid mt--8">
    <button (click)="location.back()" class="btn-sm btn btn-warning">Go back</button>        
</div>
